import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown,faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { get_all_depends } from "../../features/userSlice";
import { nodataStyle } from "../../constant/constant";
import { useT } from "../../i18n";

const statusInfo = (status) => {
   if (status==="0") return { label:'In Process', tone:'pending' };
   if (status==="-1") return { label:'Declined', tone:'failed' };
   return { label:'Success', tone:'done' };
};

const FundsHistory = () => {
   const {TYPE}=useParams();
   const { isUserLogedIn,Info,reuest_history } = useSelector((state) => state.users);
   const [fundData,setFundData]=useState([]);

    const dispatch=useDispatch();
    const { t } = useT();
    React.useEffect(()=>{
      if(isUserLogedIn){
        let data = new FormData();
        data.append('phone_number',Info?.phone_number);
        dispatch(get_all_depends({request_type:'reuest_history',data:data}));
      }
     },[isUserLogedIn,Info?.phone_number,dispatch])

     React.useEffect(()=>{
        if( Array.isArray(reuest_history) && reuest_history.length>0){
            if(TYPE==='ALL_FUND_HISTROY'){
                setFundData(reuest_history);
            }else if(TYPE==='ALL_DEPOSIT'){
            const ALL_DEBIT_HISTORY=reuest_history.filter(item => item.action_type==='Deposite');
                setFundData(ALL_DEBIT_HISTORY);
           }else if(TYPE==='APPROVED_DEPOSITE'){
                const APPROVED_HISTORY=reuest_history.filter(item => item.status==='1' && item.action_type==='Deposite'); 
                setFundData(APPROVED_HISTORY);
           }else if(TYPE==='ALL_WITHDRAWAL'){
            const ALL_WITHDRAWAL=reuest_history.filter(item => item.action_type==='Withdraw');
            setFundData(ALL_WITHDRAWAL);
           }else if(TYPE==='APPROVED_WITHDRAWAL'){
            const APPROVED_WITHDRAWAL=reuest_history.filter(item => item.status==='1' && item.action_type==='Withdraw'); 
            setFundData(APPROVED_WITHDRAWAL);
           }
        }
     },[reuest_history,TYPE]);
    
return (
        <div className="fh-screen">
           {fundData.map((data_camp, index) => {
                const isDeposit = data_camp.action_type==='Deposite';
                const status = statusInfo(data_camp.status);
                return (
                    <div className="fh-card" key={index}>
                        <span className={`fh-icon${isDeposit?'':' out'}`}><FontAwesomeIcon icon={isDeposit?faArrowDown:faArrowUp} /></span>
                        <div className="fh-main">
                            <strong>{isDeposit?t('Deposit'):t('Withdraw')}</strong>
                            <span>{data_camp.date.split('-').join('/')}</span>
                            <span className="fh-id">{data_camp.remark}</span>
                        </div>
                        <div className="fh-side">
                            <strong className={isDeposit?'in':'out'}>{isDeposit?'+':'-'}₹{data_camp.points}</strong>
                            <span className={`fh-status ${status.tone}`}>{t(status.label)}</span>
                        </div>
                    </div>
                );
           })}

        {
          (fundData.length===0) && nodataStyle(t('No history found.'))
         }
        </div>
    );
};

export default FundsHistory;
